import { isNonEmptyArray, isObject, isString } from './type-checkers'


/**
 * 
 * @param args 
 * @returns {string}
 */
export const flatten = (...args: (null | undefined | string | Record<string, (boolean | undefined | null)> | string[])[]): string => args.reduce<string[]>((prev, value) => {
    const str = parseValue(value)?.trim()
    return !!str ? [...prev, str] : prev
}, []).join(' ')

const parseValue = (value: unknown) => {
    if (!value) return
    if (isString(value)) return value
    if (isObject(value)) return Object.keys(value).reduce<string[]>((prev, key) => !!value[key] ? [...prev, key] : prev, []).join(' ')
    if (isNonEmptyArray(value)) return value.join(' ')
}